module.exports = __webpack_public_path__ + "static/media/christmasEve.bcb4b411.png";